<template lang="pug">
v-btn.bg-red.text-white(variant='outlined')
    span.ml-1
        slot Delete
</template>

<script setup lang="ts"></script>
